import { render } from "./Single.vue?vue&type=template&id=78a4ce62&scoped=true"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"

import "./Single.vue?vue&type=style&index=0&id=78a4ce62&lang=css&scoped=true"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a4ce62"]])

export default __exports__